
import { Link } from 'react-router-dom'

import './_terms.scss';

const USC = () => {

  return (
    <>
    <div className="pf-content pf-content--not-home">
        <div className="pf-content__inner">
        <div className="pf-container">
            <h2 className="pf-page__title">
            USC 2257
            </h2>
                    <div className="pf-main-list">
            <p>Last Updated: 2025/06/21</p>
            <p>Any actual human being that appears in any visual depiction of actual sexually explicit conduct 
                appearing or otherwise contained on the website located at <Link to="/">www.allfans.com</Link> (“Website”) were at least 
                18-years old at the time those visual depictions were produced.</p>
            
            <h5>Exemption: Content Produced by Third Parties</h5>
                <p>The Website’s operator is not the “producer” of any depictions of actual or simulated sexually explicit 
                    conduct that may appear on the Website. The Website’s operator limits its handling of this content and only 
                    performs the activities of transmission, storage, retrieval, hosting, or formatting of material that may depict 
                    sexually explicit conduct, all which material appears on the Website as the result of actions taken by 
                    third-party users of the Website. All parts of the Website that contain user-generated material are under the 
                    control of the relevant user, for whom the Website is provided as an online service by the operator. Under 
                    18 U.S.C. § 2257(h)(2)(B)(v) and 47 U.S.C. § 230(c), the Website’s operator may delete materials appearing on 
                    the Website as the result of actions taken by the Website’s users, which materials are considered, in the 
                    operator’s sole discretion, to be indecent, obscene, defamatory, or inconsistent with the policies and terms 
                    of use for the Website.</p>
            
            <h5>Exemption: Content Produced by Website Operator</h5>
                <p>To the extent that any images or videos appear on the Website, for which the Website’s operator may be 
                    considered the “producer,” those images and videos are exempt from the requirements of 18 U.S.C. § 2257 
                    and 28 C.F.R. Part 75 for one or more of the following reasons: (1) the produced images or videos do not 
                    portray any sexually explicit conduct defined in 18 U.S.C. § 2256(2)(A); (2) the produced images or videos 
                    do not portray depictions of the genitals or pubic area created after July 27, 2006; (3) the produced images 
                    or videos do not portray simulated sexually explicit activity occurring after the effective date of 
                    18 U.S.C. § 2257A; or (4) the produced images or videos were created before July 3, 1995.</p>
            
            <h5>Designated Records Custodian</h5>
                <p>Without limiting in any way the applicability of the above-stated exemptions, the Website’s operator has 
                    designated the custodian, whose address appears below, to be the keeper of original records described in 
                    18 U.S.C. § 2257 and 28 C.F.R. Part 75 for all materials appearing on the Website that fall in the 
                    following categories: (1) marketing and advertising materials that contain visual depictions of actual 
                    or simulated sexually explicit conduct, which materials have been acquired or created by the Website’s 
                    operator to promote the Website; or (2) materials that are not exempt, as described above.</p>
                
                <p>The named earlier records and their custodian can be found at the following location:</p>
                <p>Custodian of Records<br></br>
                Innodev Solutions Inc.<br></br>
                2108 N ST #6819
                SACRAMENTO, CA 95816
                </p>
                <div style={{ paddingTop: '220px' }}></div>

          </div>

          </div>
          </div>

          
{/*       <button className="btn btn-primary btn-primary--feedback">
        <span>Feedback</span>
      </button>
      <ul className="pf-socials">
        <li>
          <a href="#">
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.9999 3.06836C6.6983 3.06836 2.3999 7.36676 2.3999 12.6684C2.3999 17.4812 5.9455 21.4556 10.5647 22.15V15.2124H8.1895V12.6892H10.5647V11.01C10.5647 8.22996 11.9191 7.00996 14.2295 7.00996C15.3359 7.00996 15.9215 7.09236 16.1983 7.12916V9.33156H14.6223C13.6415 9.33156 13.2991 10.262 13.2991 11.31V12.6892H16.1735L15.7839 15.2124H13.2991V22.17C17.9847 21.5348 21.5999 17.5284 21.5999 12.6684C21.5999 7.36676 17.3015 3.06836 11.9999 3.06836Z"
                fill="#333232"
              />
            </svg>
          </a>
        </li>
        <li>
          <a href="#">
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.99834 3.06836C4.91114 3.06836 2.3999 5.58192 2.3999 8.66992V16.6699C2.3999 19.7571 4.91347 22.2684 8.00147 22.2684H16.0015C19.0887 22.2684 21.5999 19.7548 21.5999 16.6668V8.6668C21.5999 5.5796 19.0863 3.06836 15.9983 3.06836H7.99834ZM17.5999 6.26836C18.0415 6.26836 18.3999 6.62676 18.3999 7.06836C18.3999 7.50996 18.0415 7.86836 17.5999 7.86836C17.1583 7.86836 16.7999 7.50996 16.7999 7.06836C16.7999 6.62676 17.1583 6.26836 17.5999 6.26836ZM11.9999 7.86836C14.6471 7.86836 16.7999 10.0212 16.7999 12.6684C16.7999 15.3156 14.6471 17.4684 11.9999 17.4684C9.3527 17.4684 7.1999 15.3156 7.1999 12.6684C7.1999 10.0212 9.3527 7.86836 11.9999 7.86836ZM11.9999 9.46836C11.1512 9.46836 10.3373 9.8055 9.73716 10.4056C9.13705 11.0057 8.7999 11.8197 8.7999 12.6684C8.7999 13.5171 9.13705 14.331 9.73716 14.9311C10.3373 15.5312 11.1512 15.8684 11.9999 15.8684C12.8486 15.8684 13.6625 15.5312 14.2626 14.9311C14.8628 14.331 15.1999 13.5171 15.1999 12.6684C15.1999 11.8197 14.8628 11.0057 14.2626 10.4056C13.6625 9.8055 12.8486 9.46836 11.9999 9.46836Z"
                fill="#333232"
              />
            </svg>
          </a>
        </li>
        <li>
          <a href="#">
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.4042 3.66797C3.7572 3.66797 3.37795 4.39673 3.74795 4.92773L9.73623 13.4863L3.72451 20.5137C3.33551 20.9677 3.65776 21.668 4.25576 21.668H4.91982C5.21282 21.668 5.49154 21.5394 5.68154 21.3164L10.9198 15.1797L14.8632 20.8145C15.2382 21.3485 15.8499 21.668 16.5019 21.668H19.8358C20.4828 21.668 20.8621 20.9402 20.4921 20.4102L14.1737 11.3672L19.9003 4.6582C20.2323 4.2682 19.9553 3.66797 19.4433 3.66797H18.5976C18.3056 3.66797 18.0278 3.79558 17.8378 4.01758L12.996 9.67773L9.39443 4.52344C9.02043 3.98744 8.40976 3.66797 7.75576 3.66797H4.4042Z"
                fill="#333232"
              />
            </svg>
          </a>
        </li>
        <li>
          <a href="#">
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.0001 3.86719C8.6513 3.86719 4.30479 4.70625 4.30479 4.70625L4.29385 4.71875C2.76863 4.96268 1.6001 6.27329 1.6001 7.86719V12.6672V12.6687V17.4672V17.4688C1.60159 18.23 1.87439 18.9657 2.36954 19.5439C2.86468 20.1221 3.54972 20.5049 4.30166 20.6234L4.30479 20.6281C4.30479 20.6281 8.6513 21.4688 12.0001 21.4688C15.3489 21.4688 19.6954 20.6281 19.6954 20.6281L19.697 20.6266C20.4497 20.5082 21.1356 20.1252 21.6311 19.5463C22.1266 18.9674 22.3993 18.2307 22.4001 17.4688V17.4672V12.6687V12.6672V7.86719C22.399 7.10569 22.1263 6.36955 21.6312 5.79103C21.136 5.21252 20.4507 4.82955 19.6985 4.71094L19.6954 4.70625C19.6954 4.70625 15.3489 3.86719 12.0001 3.86719ZM9.6001 8.98594L16.0001 12.6672L9.6001 16.3484V8.98594Z"
                fill="#333232"
              />
            </svg>
          </a>
        </li>
      </ul> */}
    </div>
        </>
  );
};

export default USC;
